import { useCallback, useMemo, useState } from "react";

export const useMainLayout = () => {
  const [isMobileNavigationOpen, setIsMobileNavigationOpen] = useState(false);

  const toggleMobileNavigation = useCallback(() => {
    setIsMobileNavigationOpen((prev) => !prev);
  }, []);

  const closeMobileNavigation = useCallback(() => {
    setIsMobileNavigationOpen(false);
  }, []);

  const openMobileNavigation = useCallback(() => {
    setIsMobileNavigationOpen(true);
  }, []);

  return useMemo(
    () => ({
      isMobileNavigationOpen,
      toggleMobileNavigation,
      closeMobileNavigation,
      openMobileNavigation,
    }),
    [
      isMobileNavigationOpen,
      toggleMobileNavigation,
      closeMobileNavigation,
      openMobileNavigation,
    ],
  );
};
